import styles from './styles.module.scss';

interface IModalFooterProps {
  buttonLeft: JSX.Element;
  buttonRight: JSX.Element;
}

export const ModalFooter = ({ buttonLeft, buttonRight }: IModalFooterProps) => (
  <div className={styles.footer}>
    {buttonLeft}
    {buttonRight}
  </div>
);
